import React from 'react'
import { Route, Routes } from 'react-router-dom'
import CreditNotes from './CreditNotes'
import NewCreditNote from './NewCreditNote'
import ViewCreditNote from './ViewCreditNote'

export default function CreditNotesRoute() {
     return (
          <Routes>
               <Route path='/' element={<CreditNotes />} />
               <Route path='/new' element={<NewCreditNote />} />
               <Route path='/view/:id' element={<ViewCreditNote />} />
               <Route path='/edit/:id' element={<NewCreditNote />} />
          </Routes>
     )
}
